import React from "react";
import { GlobalTableStyles } from './globalTableStyles'
import { ApplicationProgressDetails, NoteTableHeaderList } from "../../../Models/applicationModels";
import ApplicationProgressRow from "./applicationProgressRow";
import { applicationProgressTableHeaderList } from "../../../constants/tableHeaderList";

interface IGlobalTableProps {
    tableData: ApplicationProgressDetails
}

const ApplicationProgressTable = (props: IGlobalTableProps) => {
    const { tableData } = props
    const { tableStyle, tableHeader } = GlobalTableStyles().classes

    return (
        <table className={tableStyle}>
            <tr>
                {applicationProgressTableHeaderList?.map((header: NoteTableHeaderList) => {
                    return (
                        <th
                            className={tableHeader}
                            style={{ width: header.width }}
                        >
                            {header.headerName}
                        </th>
                    )
                })}
            </tr>
            {(tableData?.lastAnsweredQuestion !== null || tableData.lastCompletedSection !== null) &&
                <ApplicationProgressRow tableData={tableData} data={tableData?.lastAnsweredQuestion} parentIndex={""} />
            }
        </table>
    )
}

export default ApplicationProgressTable